import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { EButtonMode } from '../../common/enums/button.enum';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'CustomButton',
  props: {
    mode: { default: EButtonMode.DEFAULT },
    text: null
  },
  setup(__props: any) {

  

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(["ccn-button", `ccn-button--${__props.mode}`]),
    type: "button",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit(`click`)))
  }, _toDisplayString(__props.text), 3))
}
}

})